var map = {
	"./access.svg": "1797",
	"./ai.svg": "f5f1",
	"./audio.svg": "b505",
	"./bat.svg": "6678",
	"./config.svg": "c190",
	"./css.svg": "5238",
	"./db.svg": "3d2e",
	"./dmg.svg": "d8a5",
	"./excel.svg": "4f9d",
	"./file.svg": "f469",
	"./fla.svg": "6664",
	"./flash.svg": "5937",
	"./font.svg": "0e41",
	"./html.svg": "5ee4",
	"./image.svg": "0611",
	"./ini.svg": "ec5d",
	"./jar.svg": "37a1",
	"./js.svg": "50bb",
	"./markdown.svg": "e72a",
	"./onenote.svg": "5288",
	"./pdf.svg": "998b",
	"./photoshop.svg": "19cb",
	"./php.svg": "c575",
	"./powerpoint.svg": "2203",
	"./reactjs.svg": "2524b",
	"./ts.svg": "05cf",
	"./txt.svg": "f4ff",
	"./video.svg": "953c",
	"./vue.svg": "6524",
	"./web.svg": "f889",
	"./word.svg": "0907",
	"./xfl.svg": "7dc5",
	"./zip.svg": "8e37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ff6";